// 微信-演出赛事小程序
export default {
  appName: 'wxapp_show',
  useKNB: false,
  sellChannel: 4,
  theme: 'maoyan'
};